// theme.ts
import type { ThemeConfig } from 'antd/es/config-provider';

const ThemeConfigProvider: ThemeConfig = {
  token: {
    colorPrimary: '#b3b3b3',
    colorLink: '#323232',
    colorSuccess: '#52c41a', // success state color
    colorWarning: '#faad14', // warning state color
    colorError: '#f5222d', // error state color
    fontSize: 16, // major text font size
    colorTextHeading: 'rgba(0, 0, 0, 0.85)', // heading text color
    colorText: 'black',
    colorTextSecondary: 'rgba(0, 0, 0, 0.45)', // secondary text color
    colorTextDisabled: 'rgba(0, 0, 0, 0.25)', // disable state color
    fontFamily: "'Open Sans'",
  },
};

export default ThemeConfigProvider;
